import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import EventItems from '../components/EventItems';
export default function Events() {
  const { strings } = useLanguage();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const referrer = document.referrer;
   
  }, [strings]);

  return (
    <div className="main">
       <div className="content-table max-centered">
              <div className="content-container">    
                  <div className="content-container-main show" id="content-container-main">
                   <EventItems lang={strings.lang_code}/>     
              </div>
            </div>
       </div>
    </div>
  );
}